import { _checkLogin } from '@/api/index';
import Toast from "@/utils/toast";
import { useUserStore } from '@/store/user';

// 1判断是否是微信浏览器
const isWechatBrowser = (function () {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('micromessenger');
})()

const loginMethod = (function () {
    if (isWechatBrowser) {
        return "wxLogin";
    } else {
        return "login";
    }
})()


export function setupRouterGuards(router) {

    router.beforeEach((to, from, next) => {

        if (to.name === "home") {
            if (from.name === loginMethod) {
                const userStore = useUserStore();
                if (userStore.nickname !== '') {
                    Toast('登录成功!', 'displayZone', 50, 1000, !isWechatBrowser);
                }
                next();
            } else {
                next();
            }

        }

        else if (to.name === "myProject" || to.name === "civilGPT") {
            Toast('本接口仅供 SVIP 用户使用！', 'displayZone', 50, 1800, !isWechatBrowser);
            next(false);
        }

        else {
            const userStore = useUserStore();
            _checkLogin()
                .then((res) => {
                    // 1.判断是否User存在
                    if (res.data.message === 'no user') {
                        Toast('用户已注销，请重新注册', 'displayZone', 50, 1800, !isWechatBrowser);
                        userStore.removeInfo();
                        router.push({ name: "home" });
                    } else {
                        // 2-1.判断是否跳转至登录页面
                        if (to.name === loginMethod || to.name === "register") {
                            if (res.data.code === 200) {
                                window.resizeTo(1000, 600);
                                Toast('已登录', 'displayZone', 50, 1800, !isWechatBrowser);
                                // next({ name: "home" });
                            }
                            else {
                                next();
                            }
                        }
                        // 2-2.判断是否跳转至非登录页面
                        else {
                            if (res.data.code === 200) {
                                if (to.name === "Power_WindBase_Draw") {
                                    Toast('模块加载中...', 'displayZone', 50, 1800, !isWechatBrowser);
                                }
                                next();
                            }
                            else {
                                Toast(res.data.message, 'displayZone', 50, 800, !isWechatBrowser);
                                userStore.removeInfo();
                                next({ name: loginMethod });
                            }
                        }
                    }
                    // 结束
                })
                .catch(() => {
                    Toast('请先登录', 'displayZone', 50, 1800, !isWechatBrowser);
                    userStore.removeInfo();
                    next({ name: loginMethod });
                });
        }
    });



}